import React from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Form,
  Image,
  FormGroup,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import {
  importAbsensi,
  getAbsensi,
  exportAbsensi,
  getBelumAbsen,
  getAbsensiManual,
  deleteAbsenManual,
  createAbsenManual,
  editAbsenManual,
  exportAbsensiPdf,
  editKategoriAbsenBackoffice,
  listKategoriAbsen,
} from "../../../stores";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ReactDatetime from "react-datetime";
import moment from "moment";
import * as XLSX from "xlsx";
import momentTZ from "moment-timezone";
import DataTable from "react-data-table-component";
import ReactPaginate from "react-paginate";
import "../css/Pagination.css";
// Loading Table
import { ColorRing } from "react-loader-spinner";
import Swal from "sweetalert2";

function ReactTables() {
  const dispatch = useDispatch();
  const date = new Date();
  const training = useSelector((state) => state.trainingReducer);
  const [modal, setModal] = React.useState(false);
  const [modalAbsenManual, setModalAbsenManual] = React.useState(false);

  const [tampilModal, setTampilModal] = React.useState("");
  const [data, setData] = React.useState([]);
  const [dataAbsen, setDataAbsen] = React.useState([]);
  const [dataJson, setDataJson] = React.useState(null);
  const [dariTgl, setDariTgl] = React.useState(
    new Date(date.getFullYear(), date.getMonth(), 1).setHours(0, 0, 0, 0),
  );
  const [smpTgl, setSmpTgl] = React.useState(new Date().setHours(23, 59, 0, 0));
  const [gambar, setGambar] = React.useState([]);

  // Pagination Absen
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState(searchText);

  // Pagination Belum Absen
  const [totalPerHalamanBelumAbsen, setTotalPerHalamanBelumAbsen] =
    React.useState(10);
  const [loadingBelumAbsen, setLoadingBelumAbsen] = React.useState(false);
  const [pageBelumAbsen, setPageBelumAbsen] = React.useState(0);
  const [dataBelumAbsen, setDataBelumAbsen] = React.useState([]);

  // Pagination Belum Absen
  const [totalPerHalamanAbsenManual, setTotalPerHalamanAbsenManual] =
    React.useState(10);
  const [loadingAbsenManual, setLoadingAbsenManual] = React.useState(false);
  const [pageAbsenManual, setPageAbsenManual] = React.useState(0);
  const [dataAbsenManual, setDataAbsenManual] = React.useState([]);
  const [listKategoriAbsenBackoffice, setListKategoriAbsenBackoffice] =
    React.useState([]);
  const [pilihShift, setPilihShift] = React.useState([]);
  const [detailDataManual, setDetailDataManual] = React.useState([]);
  const [nopeg, setNopeg] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [jabatan, setJabatan] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [shift, setShift] = React.useState("");
  const [keterangan, setKeterangan] = React.useState("");
  const [tgl_absen_masuk, set_tgl_absen_masuk] = React.useState(
    new Date().setHours(7, 0, 0, 0),
  );
  const [tgl_absen_keluar, set_tgl_absen_keluar] = React.useState(
    new Date().setHours(15, 0, 0, 0),
  );
  const [idAbsen, setIdAbsen] = React.useState("");
  // Export data
  const [tglAwlExport, setTglAwalExport] = React.useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [tglAkhirExport, setTglAkhirExport] = React.useState(
    moment().format("YYYY-MM-DD"),
  );
  const [exportPdf, setExportPdf] = React.useState(
    moment().format("MMMM YYYY"),
  );
  const [modalExport, setModalExport] = React.useState(false);
  const [modalExportPdf, setModalExportPdf] = React.useState(false);

  const [modalPreviewFoto, setModalPreviewFoto] = React.useState(false);

  // Edit Kategori Absen
  const [idAbsenBackoffice, setIdAbsenBackoffice] = React.useState("");
  const [idKategoriAbsenLamaBackoffice, setIdKategoiAbsenLamaBackoffice] =
    React.useState("");
  const [idKategoriAbsenBaruBackoffice, setIdKategoriAbsenBaruBackoffice] =
    React.useState("");
  const [tglMasukBackoffice, setTglMasukBackoffice] = React.useState("");

  const statusOption = [
    { value: "Belum Absen", label: "Belum Absen" },
    { value: "Masuk", label: "Masuk" },
    { value: "Tidak Masuk", label: "Tidak Masuk" },
    // { value: "Sakit", label: "Sakit" },
    // {value:"Terlambat",label:"Terlambat"},
    // {value:"Keluarga",label:"Keluarga"},
    // {value:"Cuti",label:"Cuti"},
  ];

  const selectedStatusOption =
    statusOption.find((opt) => opt.value === status) || null;

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
    setPage(0);
  };
  const handlePageSizeChangeBelumAbsen = (selectedOption) => {
    setTotalPerHalamanBelumAbsen(selectedOption.value);
    setPageBelumAbsen(0);
  };
  const handlePageSizeChangeAbsenManual = (selectedOption) => {
    setTotalPerHalamanAbsenManual(selectedOption.value);
    setPageBelumAbsen(0);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const handleClearSearch = () => {
    setSearchText("");
  };

  // Style Table Absen
  const TableLoader = () => (
    <div
      style={{
        padding: "40px 0",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ColorRing
        visible={true}
        height="60"
        width="60"
        ariaLabel="color-ring-loading"
        colors={["#394978", "#394978", "#394978", "#394978", "#394978"]}
      />
    </div>
  );
  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  let totalRecord = training?.listAbsensi?.total ?? 0;
  let totalPage = Math.ceil(totalRecord / totalPerHalaman);

  // Style Tabel Belum Absen
  const TableLoaderBelumAbsen = () => (
    <div
      style={{
        padding: "40px 0",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ColorRing
        visible={true}
        height="60"
        width="60"
        ariaLabel="color-ring-loading"
        colors={["#394978", "#394978", "#394978", "#394978", "#394978"]}
      />
    </div>
  );
  let optionsBelumAbsen = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const filteredData = React.useMemo(() => {
    if (!Array.isArray(dataBelumAbsen)) return [];

    if (!searchText) return dataBelumAbsen;

    const keyword = searchText.toLowerCase();

    return dataBelumAbsen.filter(
      (d) =>
        d.nopeg?.toLowerCase().includes(keyword) ||
        d.nama_karyawan?.toLowerCase().includes(keyword) ||
        d.jabatan?.toLowerCase().includes(keyword),
    );
  }, [dataBelumAbsen, searchText]);

  const sortedDataBelumAbsen = React.useMemo(() => {
    return [...filteredData].sort((a, b) =>
      (a.nopeg ?? "").localeCompare(b.nopeg ?? "", "id", {
        numeric: true,
      }),
    );
  }, [filteredData]);

  let totalBelumAbsen = sortedDataBelumAbsen?.length ?? 0;
  let totalPageBelumAbsen = Math.ceil(
    totalBelumAbsen / totalPerHalamanBelumAbsen,
  );

  const startIndex = pageBelumAbsen * totalPerHalamanBelumAbsen;
  const endIndex = startIndex + totalPerHalamanBelumAbsen;

  const paginatedDataBelumAbsen = sortedDataBelumAbsen?.slice(
    startIndex,
    endIndex,
  );

  // Edit gambar
  const onAddImage = (files) => {
    setGambar((prev) => [...prev, ...Array.from(files)]);
  };
  const onRemoveImage = (index) => {
    setGambar((prev) => prev.filter((_, i) => i !== index));
  };

  // Absen Manual
  // Style Table Absen
  const TableLoaderAbsenManual = () => (
    <div
      style={{
        padding: "40px 0",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ColorRing
        visible={true}
        height="60"
        width="60"
        ariaLabel="color-ring-loading"
        colors={["#394978", "#394978", "#394978", "#394978", "#394978"]}
      />
    </div>
  );
  const optionsAbsenManual = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  let totalRecordAbsenManual = training?.listAbsenManual?.totalDocs ?? 0;
  let totalPageAbsenManual = Math.ceil(
    totalRecordAbsenManual / totalPerHalamanAbsenManual,
  );

  // ================================================================================
  // const customStyles = {
  //   rows: {
  //     style: {
  //       height: 50, // override the row height
  //     },
  //   },
  //   headRow: {
  //     style: {
  //       minHeight: 35,
  //       backgroundColor: "#F8F8F8",
  //       // fontFamily: "Poppins",
  //       justifyContent: "center",
  //     },
  //   },
  //   headCells: {
  //     style: {
  //       minHeight: 50,
  //       fontWeight: "bold",
  //       fontSize: 14,
  //       // "&:first-child": {
  //       //   borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
  //       // },
  //     },
  //   },
  //   cells: {
  //     style: {
  //       minHeight: 50,
  //       // "&:first-child": {
  //       //   borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
  //       // },
  //     },
  //   },
  // };
  const customStyles = {
    table: {
      style: {
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      },
    },

    headRow: {
      style: {
        minHeight: "40px",
        background: "linear-gradient(90deg, #3473B6, #4A90E2)",
        borderBottom: "2px solid #e5e7eb",
      },
    },

    headCells: {
      style: {
        color: "#ffffff",
        fontSize: "12px",
        fontWeight: "500",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        justifyContent: "center",
        padding: "6px 8px",
      },
    },

    rows: {
      style: {
        minHeight: "40px",
        fontSize: "12px",
        color: "#374151",
        backgroundColor: "#ffffff",
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #e5e7eb",
        },
      },
      stripedStyle: {
        backgroundColor: "#f9fafb",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#eff6ff",
        cursor: "pointer",
        transition: "background-color 0.2s ease",
      },
    },

    cells: {
      style: {
        padding: "6px 12px",
        justifyContent: "center",
      },
    },
  };

  // function onsubmit(e) {
  //   e.preventDefault();
  //   let fd = new FormData();
  //   fd.append("file", dataAbsen);
  //   importAbsensi(fd);
  // }

  const history = useHistory();

  React.useEffect(() => {
    let tmp =
      training.listAbsensi.data &&
      training.listAbsensi.data.map((val, index) => {
        return {
          ...val,
          // tglAbsen: moment(val.tanggal).format("DD MMM YYYY"),
          actions: (
            <div
              className="actions-right"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ pointerEvents: "none" }}>
                    Detail Absen
                  </Tooltip>
                }
              >
                <Button
                  onClick={() => {
                    setModal(true);
                    setDataAbsen(val);
                  }}
                  variant="success"
                  size="md"
                  className="btn-link remove text-success"
                >
                  <i className="fa fa-info-circle fa-lg" />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ pointerEvents: "none" }}>
                    Edit Absen
                  </Tooltip>
                }
              >
                <Button
                  onClick={() => {
                    setModalAbsenManual(true);
                    setTampilModal("edit kategori shift");
                    setIdAbsenBackoffice(val.id_absen);
                    setIdKategoiAbsenLamaBackoffice(val.id_shift);
                    setIdKategoriAbsenBaruBackoffice(val.id_shift);
                    setTglMasukBackoffice(val.tgl_masuk);
                    setNopeg(val.nopeg);
                    setNama(val.nama_karyawan);
                    setJabatan(val.jabatan);
                    setStatus(val.status);
                  }}
                  variant="primary"
                  size="md"
                  className="btn-link remove text-primary"
                >
                  <i className="fa fa-edit fa-lg" />
                </Button>
              </OverlayTrigger>
            </div>
          ),
          // ),
        };
      });
    setData(tmp);
  }, [training.listAbsensi]);

  React.useEffect(() => {
    setPage(0);
  }, [debouncedSearch, dariTgl, smpTgl]);

  React.useEffect(() => {
    let tmp =
      training.listAbsenManual.data &&
      training.listAbsenManual.data.map((val, index) => {
        return {
          ...val,
          // tglAbsen: moment(val.tanggal).format("DD MMM YYYY"),
          actions: (
            // we've added some custom button actions

            <div
              className="actions-right"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ pointerEvents: "none" }}>
                    Edit Absen Manual
                  </Tooltip>
                }
              >
                <Button
                  onClick={() => {
                    setModalAbsenManual(true);
                    setTampilModal("edit");
                    setNopeg(val.nopeg);
                    setNama(val.nama_karyawan);
                    setJabatan(val.jabatan);
                    setStatus(val.status);
                    setShift(val.shift);
                    setPilihShift(val.shift);
                    setIdAbsen(val._id);
                    // Parse tgl_masuk dan jam_masuk untuk check-in
                    if (val.tgl_masuk && val.jam_masuk) {
                      const checkInDateTime = moment(
                        `${val.tgl_masuk} ${val.jam_masuk}`,
                        "YYYY-MM-DD HH:mm:ss",
                      )
                        .toDate()
                        .getTime();
                      set_tgl_absen_masuk(checkInDateTime);
                    }
                    // Parse tgl_pulang dan jam_keluar untuk check-out
                    if (val.tgl_pulang && val.jam_keluar) {
                      const checkOutDateTime = moment(
                        `${val.tgl_pulang} ${val.jam_keluar}`,
                        "YYYY-MM-DD HH:mm:ss",
                      )
                        .toDate()
                        .getTime();
                      set_tgl_absen_keluar(checkOutDateTime);
                    }
                    setKeterangan(val.keterangan);
                    // Load existing images untuk edit
                    if (val.dokumen) {
                      const existingImages = Array.isArray(val.dokumen)
                        ? val.dokumen.map((url) => ({
                            name: url.split("/").pop(),
                            url,
                          }))
                        : [
                            {
                              name: val.dokumen.split("/").pop(),
                              url: val.dokumen,
                            },
                          ];

                      setGambar(existingImages);
                    } else {
                      setGambar([]);
                    }
                  }}
                  variant="link"
                  className="p-0 border-0 shadow-none"
                  style={{ textDecoration: "none" }}
                >
                  <i
                    className="fas fa-edit fa-lg"
                    style={{
                      color: "#ff8000",
                    }}
                  />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ pointerEvents: "none" }}>
                    Hapus Absen
                  </Tooltip>
                }
              >
                <Button
                  onClick={() => {
                    Swal.fire({
                      title: "Hapus Absen",
                      text: "Yakin ingin menghapus absen ini?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Ya, Hapus!",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        Swal.fire({
                          title: "Loading...",
                          allowOutsideClick: false,
                          showConfirmButton: false,
                          onBeforeOpen: () => {
                            Swal.showLoading();
                          },
                        });
                        deleteAbsenManual({ idAbsen: val._id }).then(
                          (response) => {
                            if (response.status === 200) {
                              Swal.fire({
                                position: "center",
                                icon: "success",
                                title: response.data.message,
                                showConfirmButton: false,
                                timer: 1500,
                              });

                              getAbsensi(dispatch, {
                                page: page + 1,
                                limit: totalPerHalaman,
                                cari: searchText,
                                dariTgl: momentTZ(new Date(smpTgl))
                                  .tz("Asia/Jakarta")
                                  .format("YYYY-MM-DD"),
                                smpTgl: momentTZ(new Date(smpTgl))
                                  .tz("Asia/Jakarta")
                                  .format("YYYY-MM-DD"),
                                search: searchText,
                              });

                              getBelumAbsen(dispatch, {
                                dariTgl: momentTZ(new Date(smpTgl))
                                  .tz("Asia/Jakarta")
                                  .format("YYYY-MM-DD"),
                                smpTgl: momentTZ(new Date(smpTgl))
                                  .tz("Asia/Jakarta")
                                  .format("YYYY-MM-DD"),
                              });

                              getAbsensiManual(dispatch, {
                                page: pageAbsenManual + 1,
                                limit: totalPerHalamanAbsenManual,
                                cari: searchText,
                                dariTgl: momentTZ(new Date(smpTgl))
                                  .tz("Asia/Jakarta")
                                  .format("YYYY-MM-DD"),
                                smpTgl: momentTZ(new Date(smpTgl))
                                  .tz("Asia/Jakarta")
                                  .format("YYYY-MM-DD"),
                                search: searchText,
                              });
                            } else if (response.status === 400) {
                              Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response.data.message,
                              });
                            } else {
                              Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response.data.message,
                              });
                            }
                          },
                        );
                      }
                    });
                    //  deleteGedung(val._id);
                  }}
                  variant="danger"
                  size="md"
                  className="btn-link remove text-danger"
                >
                  <i className="fa fa-times fa-lg" />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ pointerEvents: "none" }}>
                    Detail Absen
                  </Tooltip>
                }
              >
                <Button
                  onClick={() => {
                    setModal(true);
                    setDataAbsen(val);
                  }}
                  variant="link"
                  className="p-0 border-0 shadow-none"
                  style={{ textDecoration: "none" }}
                >
                  <i
                    className="fas fa-info-circle fa-lg"
                    style={{
                      color: "#0BDA51",
                    }}
                  />
                </Button>
              </OverlayTrigger>
            </div>

            // ),
          ),
        };
      });
    setDataAbsenManual(tmp);
  }, [training.listAbsenManual]);

  React.useEffect(() => {
    setPageBelumAbsen(0);
  }, [searchText]);

  // Reset form ketika modal dibuka/ditutup atau smpTgl berubah
  React.useEffect(() => {
    if (!modalAbsenManual) {
      setNopeg("");
      setNama("");
      setJabatan("");
      setStatus("");
      setShift("");
      setKeterangan("");
    }
  }, [modalAbsenManual]);

  React.useEffect(() => {
    if (modalAbsenManual && tampilModal === "add") {
      set_tgl_absen_masuk(
        moment(smpTgl).hours(7).minutes(0).seconds(0).toDate().getTime(),
      );
      set_tgl_absen_keluar(
        moment(smpTgl).hours(7).minutes(0).seconds(0).toDate().getTime(),
      );
    }
  }, [smpTgl, modalAbsenManual, tampilModal]);

  React.useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 400);

    return () => clearTimeout(t);
  }, [searchText]);

  // get Belum Absen
  React.useEffect(() => {
    let tmp =
      training.belumAbsen.data &&
      training.belumAbsen.data.map((val) => {
        return {
          ...val,
          actions: (
            // we've added some custom button actions

            <div className="actions-right">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ pointerEvents: "none" }}>
                    Absen Manual
                  </Tooltip>
                }
              >
                <Button
                  onClick={() => {
                    setModalAbsenManual(true);
                    setTampilModal("add");
                    setNopeg(val.nopeg);
                    setNama(val.nama_karyawan);
                    setJabatan(val.jabatan);
                    setStatus(val.status);
                    setShift(val.shift);
                    setGambar([]);
                    set_tgl_absen_masuk(
                      moment(smpTgl)
                        .hours(7)
                        .minutes(0)
                        .seconds(0)
                        .toDate()
                        .getTime(),
                    );
                    set_tgl_absen_keluar(
                      moment(smpTgl)
                        .hours(7)
                        .minutes(0)
                        .seconds(0)
                        .toDate()
                        .getTime(),
                    );
                  }}
                  variant="link"
                  className="p-0 border-0 shadow-none"
                  style={{ textDecoration: "none" }}
                >
                  <i
                    className="fas fa-edit fa-lg"
                    style={{
                      color: "#069AF3",
                    }}
                  />
                </Button>
              </OverlayTrigger>
            </div>

            // ),
          ),
        };
      });
    setDataBelumAbsen(tmp);
  }, [training.belumAbsen]);

  React.useEffect(() => {
    let tmp = training.listKategoriAbsen.data
      ? training.listKategoriAbsen.data.map((val, index) => {
          return {
            label: val.nama_kategori,
            value: val.id_kategori,
          };
        })
      : [];
    setListKategoriAbsenBackoffice(tmp);
  }, [training.listKategoriAbsen]);

  // =============================================================

  React.useEffect(() => {
    setLoading(true);
    getAbsensi(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
      dariTgl: momentTZ(new Date(smpTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
      smpTgl: momentTZ(new Date(smpTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
      search: searchText,
    }).then((response) => {
      setLoading(false);
    });
  }, [page, totalPerHalaman, debouncedSearch, dariTgl, smpTgl]);

  React.useEffect(() => {
    setLoadingBelumAbsen(true);
    getBelumAbsen(dispatch, {
      dariTgl: momentTZ(new Date(smpTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
      smpTgl: momentTZ(new Date(smpTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
    }).then((response) => {
      setLoadingBelumAbsen(false);
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    listKategoriAbsen(dispatch);
  }, []);

  React.useEffect(() => {
    setLoadingAbsenManual(true);
    getAbsensiManual(dispatch, {
      page: pageAbsenManual + 1,
      limit: totalPerHalamanAbsenManual,
      cari: searchText,
      dariTgl: momentTZ(new Date(smpTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
      smpTgl: momentTZ(new Date(smpTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
      search: searchText,
    }).then((response) => {
      setLoadingAbsenManual(false);
    });
  }, [
    pageAbsenManual,
    totalPerHalamanAbsenManual,
    debouncedSearch,
    dariTgl,
    smpTgl,
  ]);

  const exportAbsen = () => {
    exportAbsensi({
      dariTgl: moment(tglAwlExport).format("YYYY-MM-DD"),
      smpTgl: moment(tglAkhirExport).format("YYYY-MM-DD"),
    });
  };

  const exportAbsenPdf = () => {
    exportAbsensiPdf({
      dariTgl: moment(exportPdf).startOf("month").format("YYYY-MM-DD"),
      smpTgl: moment(exportPdf).endOf("month").format("YYYY-MM-DD"),
    });
  };

  // Create Absen Manual
  const absenManual = () => {
    if (status === "Belum Absen") {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Silahkan pilih status selain Belum Absen!",
      });
    }
    if (pilihShift.label === undefined || keterangan === "") {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Semua field harus diisi!",
      });
    }

    Swal.fire({
      title: "Membuat Absen Manual",
      text: "Yakin ingin membuat absen ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Buat!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        let fd = new FormData();
        fd.append("nopeg", nopeg);
        fd.append("nama_karyawan", nama);
        fd.append("jabatan", jabatan);
        fd.append("status", status);
        fd.append("shift", pilihShift.label);
        fd.append("keterangan", keterangan);
        fd.append(
          "tgl_absen_masuk",
          moment(tgl_absen_masuk).format("YYYY-MM-DD HH:mm:ss"),
        );
        fd.append(
          "tgl_absen_pulang",
          moment(tgl_absen_keluar).format("YYYY-MM-DD HH:mm:ss"),
        );

        gambar.map((val, index) => [fd.append("dokumen", val)]);
        createAbsenManual(fd)
          // createAbsenManual({
          //   nopeg: nopeg,
          //   nama_karyawan: nama,
          //   jabatan: jabatan,
          //   status: status,
          //   keterangan: keterangan,
          //   tgl_absen_masuk: moment(tgl_absen_masuk).format(
          //     "YYYY-MM-DD HH:mm:ss"
          //   ),
          //   tgl_absen_pulang: moment(tgl_absen_keluar).format(
          //     "YYYY-MM-DD HH:mm:ss"
          //   ),
          // })
          .then((response) => {
            if (response.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              setModalAbsenManual(false);
              getAbsensi(dispatch, {
                page: page + 1,
                limit: totalPerHalaman,
                cari: searchText,
                dariTgl: momentTZ(new Date(smpTgl))
                  .tz("Asia/Jakarta")
                  .format("YYYY-MM-DD"),
                smpTgl: momentTZ(new Date(smpTgl))
                  .tz("Asia/Jakarta")
                  .format("YYYY-MM-DD"),
                search: searchText,
              });

              getBelumAbsen(dispatch, {
                dariTgl: momentTZ(new Date(smpTgl))
                  .tz("Asia/Jakarta")
                  .format("YYYY-MM-DD"),
                smpTgl: momentTZ(new Date(smpTgl))
                  .tz("Asia/Jakarta")
                  .format("YYYY-MM-DD"),
              });
              getAbsensiManual(dispatch, {
                page: pageAbsenManual + 1,
                limit: totalPerHalamanAbsenManual,
                cari: searchText,
                dariTgl: momentTZ(new Date(smpTgl))
                  .tz("Asia/Jakarta")
                  .format("YYYY-MM-DD"),
                smpTgl: momentTZ(new Date(smpTgl))
                  .tz("Asia/Jakarta")
                  .format("YYYY-MM-DD"),
                search: searchText,
              });
            } else if (response.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          });
      }
    });
  };
  const editManual = () => {
    Swal.fire({
      title: "Edit Absen Manual",
      text: "Yakin ingin edit absen ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Edit!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire({
        //   title: "Loading...",
        //   allowOutsideClick: false,
        //   showConfirmButton: false,
        //   onBeforeOpen: () => {
        //     Swal.showLoading();
        //   },
        // });
        // editAbsenManual({
        //   idAbsen: idAbsen,
        //   status: status,
        //   keterangan: keterangan,
        //   tgl_absen_masuk: moment(tgl_absen_masuk).format(
        //     "YYYY-MM-DD HH:mm:ss"
        //   ),
        //   tgl_absen_pulang: moment(tgl_absen_keluar).format(
        //     "YYYY-MM-DD HH:mm:ss"
        //   ),
        // }).
        let fd = new FormData();
        fd.append("idAbsen", idAbsen);
        fd.append("status", status);
        fd.append("shift", pilihShift.label);
        fd.append("keterangan", keterangan);
        fd.append(
          "tgl_absen_masuk",
          moment(tgl_absen_masuk).format("YYYY-MM-DD HH:mm:ss"),
        );
        fd.append(
          "tgl_absen_pulang",
          moment(tgl_absen_keluar).format("YYYY-MM-DD HH:mm:ss"),
        );
        const fotoLama = gambar
          .filter((g) => !(g instanceof File))
          .map((g) => g.url);

        const fotoBaru = gambar.filter((g) => g instanceof File);
        fotoLama.forEach((imageLama) => fd.append("fotoLama", imageLama));
        fotoBaru.forEach((f) => fd.append("dokumen", f));

        // gambar.map((val, index) => [fd.append("dokumen", val)]);
        editAbsenManual(fd).then((response) => {
          if (response.status === 200) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            setModalAbsenManual(false);
            getAbsensi(dispatch, {
              page: page + 1,
              limit: totalPerHalaman,
              cari: searchText,
              dariTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              smpTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              search: searchText,
            });

            getBelumAbsen(dispatch, {
              dariTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              smpTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
            });
            getAbsensiManual(dispatch, {
              page: pageAbsenManual + 1,
              limit: totalPerHalamanAbsenManual,
              cari: searchText,
              dariTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              smpTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              search: searchText,
            });
          } else if (response.status === 400) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          }
        });
      }
    });
  };
  const editKategori = () => {
    Swal.fire({
      title: "Edit Kategori Absen",
      text: "Yakin ingin edit absen ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Edit!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (keterangan === "" || keterangan === "-") {
          return Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Semua field harus diisi!",
          });
        }
        // Swal.fire({
        //   title: "Loading...",
        //   allowOutsideClick: false,
        //   showConfirmButton: false,
        //   onBeforeOpen: () => {
        //     Swal.showLoading();
        //   },
        // });
        // editAbsenManual({
        //   idAbsen: idAbsen,
        //   status: status,
        //   keterangan: keterangan,
        //   tgl_absen_masuk: moment(tgl_absen_masuk).format(
        //     "YYYY-MM-DD HH:mm:ss"
        //   ),
        //   tgl_absen_pulang: moment(tgl_absen_keluar).format(
        //     "YYYY-MM-DD HH:mm:ss"
        //   ),
        // }).

        gambar.map((val, index) => [fd.append("dokumen", val)]);
        editKategoriAbsenBackoffice({
          idKategoriAbsenLamaBackoffice: idKategoriAbsenLamaBackoffice,
          idKategoriAbsenBaruBackoffice: pilihShift.value,
          idAbsenBackoffice: idAbsenBackoffice,
          tanggalAbsen: tglMasukBackoffice,
          namaPegawai: nama,
          nopeg: nopeg,
          keterangan: keterangan,
        }).then((response) => {
          if (response.status === 200) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            setModalAbsenManual(false);
            getAbsensi(dispatch, {
              page: page + 1,
              limit: totalPerHalaman,
              cari: searchText,
              dariTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              smpTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              search: searchText,
            });

            getBelumAbsen(dispatch, {
              dariTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              smpTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
            });
            getAbsensiManual(dispatch, {
              page: pageAbsenManual + 1,
              limit: totalPerHalamanAbsenManual,
              cari: searchText,
              dariTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              smpTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              search: searchText,
            });
          } else if (response.status === 400) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          }
        });
      }
    });
  };

  // Data yang ditampilkan
  const colPencairan = [
    {
      name: "No",
      minWidth: "50px",
      center: true,
      selector: (row, index) => page * totalPerHalaman + index + 1,
    },
    {
      name: "Personnel ID",
      minWidth: "150px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Name",
      minWidth: "250px",
      center: true,
      selector: (row) => row.nama_karyawan,
    },
    {
      name: "Position",
      minWidth: "250px",
      center: true,
      selector: (row) => row.jabatan,
    },
    {
      name: "Shift",
      minWidth: "150px",
      center: true,
      selector: (row) => row.shift || "-",
    },
    {
      name: "Day Check-In",
      minWidth: "150px",
      center: true,
      selector: (row) => row.hari_masuk || "-",
    },
    {
      name: "Date Check-In",
      minWidth: "150px",
      center: true,
      selector: (row) =>
        row.tgl_masuk
          ? moment(row.tgl_masuk, "YYYY-MM-DD").format("DD-MM-YYYY")
          : "-",
    },
    {
      name: "Time Check-In",
      minWidth: "150px",
      center: true,
      selector: (row) => row.jam_masuk || "-",
    },
    {
      name: "Day Check-Out",
      minWidth: "200px",
      center: true,
      selector: (row) => row.hari_pulang || "-",
    },
    {
      name: "Date Check-Out",
      minWidth: "200px",
      center: true,
      selector: (row) => (row.tgl_pulang ? row.tgl_pulang : "-"),
    },

    {
      name: "Time Checkout",
      minWidth: "200px",
      center: true,
      selector: (row) => row.jam_keluar || "-",
    },
    {
      name: "Status",
      minWidth: "250px",
      center: true,
      selector: (row) => row.status || "-",
    },
    {
      name: "Action",
      minWidth: "150px",
      center: true,
      selector: (row) => row.actions,
    },
  ];
  const colPencairanBelumAbsen = [
    {
      name: "No",
      minWidth: "50px",
      center: true,
      selector: (row, index) => page * totalPerHalaman + index + 1,
    },
    {
      name: "Personnel ID",
      minWidth: "120px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Name",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama_karyawan,
    },
    {
      name: "Position",
      minWidth: "200px",
      center: true,
      selector: (row) => row.jabatan,
    },

    {
      name: "Status",
      minWidth: "150px",
      center: true,
      selector: (row) => row.status || "-",
    },
    {
      name: "Action",
      minWidth: "150px",
      center: true,
      selector: (row) => row.actions,
    },
  ];

  const colPencairanAbsenManual = [
    {
      name: "No",
      minWidth: "50px",
      center: true,
      selector: (row, index) => page * totalPerHalaman + index + 1,
    },
    {
      name: "Personnel ID",
      minWidth: "150px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Name",
      minWidth: "250px",
      center: true,
      selector: (row) => row.nama_karyawan,
    },
    {
      name: "Position",
      minWidth: "250px",
      center: true,
      selector: (row) => row.jabatan,
    },
    {
      name: "Shift",
      minWidth: "150px",
      center: true,
      selector: (row) => row.shift || "-",
    },
    {
      name: "Day Check-In",
      minWidth: "150px",
      center: true,
      selector: (row) => row.hari_masuk || "-",
    },
    {
      name: "Date Check-In",
      minWidth: "150px",
      center: true,
      selector: (row) =>
        row.tgl_masuk
          ? moment(row.tgl_masuk, "YYYY-MM-DD").format("DD-MM-YYYY")
          : "-",
    },
    {
      name: "Time Check-In",
      minWidth: "150px",
      center: true,
      selector: (row) => row.jam_masuk || "-",
    },
    {
      name: "Day Check-Out",
      minWidth: "200px",
      center: true,
      selector: (row) => row.hari_pulang || "-",
    },
    {
      name: "Date Check-Out",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.tgl_pulang
          ? moment(row.tgl_pulang, "YYYY-MM-DD").format("DD-MM-YYYY")
          : "-",
    },

    {
      name: "Time Checkout",
      minWidth: "200px",
      center: true,
      selector: (row) => row.jam_keluar || "-",
    },
    {
      name: "Status",
      minWidth: "250px",
      center: true,
      selector: (row) => row.status || "-",
    },
    {
      name: "Action",
      minWidth: "150px",
      center: true,
      selector: (row) => row.actions,
    },
  ];

  return (
    <>
      <div
        id="previewImage"
        style={{
          display: modalPreviewFoto ? "block" : "none",
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: "9999",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={modalPreviewFoto}
          alt="Preview"
          style={{
            borderRadius: "5px",
            boxShadow: "4px 4px 8px 0px rgba(0,0,0,0.75)",
            maxHeight: "80%",
            maxWidth: "80%",
            objectFit: "contain",
            background: "transparent",
            position: "absolute",
            top: "50%", // Posisi vertikal ke tengah
            left: "50%", // Posisi horizontal ke tengah
            transform: "translate(-50%, -50%)",
          }}
        />
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "20px",
            cursor: "pointer",
          }}
          onClick={() => setModalPreviewFoto("")}
        >
          &times;
        </button>
      </div>

      <Container fluid>
        <Row className="mb-3">
          {/* <Col md="3">
            <h4 className="title">Start Date</h4>
            <Form.Group>
              <ReactDatetime
                inputProps={{
                  className: "form-control",
                  placeholder: "Date Picker Here",
                  readOnly: true,
                  style: {
                    cursor: "pointer",
                    backgroundColor: "white",
                    color: "black !important",
                  },
                }}
                onChange={(e) => {
                  setDariTgl(e.toDate().setHours(0, 0, 0, 0));
                }}
                value={dariTgl}
                initialValue={dariTgl}
                timeFormat={false}
              ></ReactDatetime>
            </Form.Group>
          </Col> */}
          <Col md="3">
            <h4 className="title">Select Date</h4>
            <Form.Group>
              <ReactDatetime
                inputProps={{
                  className: "form-control",
                  placeholder: "Date Picker Here",
                  readOnly: true,
                  style: {
                    cursor: "pointer",
                    backgroundColor: "white",
                    color: "black !important",
                  },
                }}
                onChange={(e) => {
                  setSmpTgl(e.toDate().setHours(23, 59, 0, 0));
                }}
                value={smpTgl}
                initialValue={smpTgl}
                timeFormat={false}
              ></ReactDatetime>
            </Form.Group>
          </Col>
          <Col md="3">
            <h4 className="title">Search</h4>
            <InputGroup>
              <Form.Control
                style={{
                  paddingLeft: "10px",
                }}
                type="text"
                value={searchText}
                onChange={handleSearch}
                placeholder="Personnel ID, Name"
              />
              <InputGroup.Append>
                <InputGroup.Text
                  className="input-group-sm mb-1"
                  style={{
                    cursor: "pointer",
                    marginLeft: "auto",
                  }}
                  onClick={handleClearSearch}
                >
                  <i class="fas fa-times"></i>
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Col>
          <Col md="4">
            <h4 className="title">Export Attendance</h4>
            <Row>
              <Button
                style={{
                  fontSize: 12,
                  fontWeight: "bold",
                  backgroundColor: "#4CBB17",
                  border: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => setModalExport(true)}
              >
                <i className="fas fa-file-excel"></i>
                Export Excel
              </Button>
              <Button
                style={{
                  fontSize: 12,
                  fontWeight: "bold",
                  marginLeft: "15px",
                  backgroundColor: "#F62217",
                  border: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => setModalExportPdf(true)}
              >
                <i className="fas fa-file-pdf"></i>
                Export PDF
              </Button>
              <Col>
                {/* <Button
                  onClick={() => {
                    // console.log(dariTgl, smpTgl);
                    // console.log(moment(dariTgl).format("DD-MM-YYYY"));
                    exportAbsenHeadCount();
                  }}
                  className="btn-wd btn-outline mr-1"
                  type="button"
                  variant={"info"}
                >
                  Export Headcount
                </Button> */}
              </Col>
            </Row>
          </Col>
        </Row>
        {/* <Button
          className="btn-wd mr-1"
          onClick={() => {
            setModal(true);
          }}
          variant="primary"
        >
          Uploading the Attendance
        </Button> */}
        <Row>
          <Col md="12">
            <h4 className="title">Personnel Attendence</h4>

            <Card>
              <Card.Body>
                <DataTable
                  columns={colPencairan}
                  data={data}
                  // {listPencairan.filter(
                  //   (row) =>
                  //     row.id_pinjaman
                  //       .toLowerCase()
                  //       .includes(searchText.toLowerCase()) ||
                  //     row.namaLengkap
                  //       .toLowerCase()
                  //       .includes(searchText.toLowerCase())
                  // )}
                  customStyles={customStyles}
                  paginationPerPage={totalPerHalaman}
                  progressPending={loading}
                  progressComponent={<TableLoader />}
                />

                <div style={{ marginTop: 35 }}>
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Col>
                      <Row style={{ alignItems: "center" }}>
                        <div
                          style={{
                            paddingRight: 0,
                            marginLeft: 20,
                            marginRight: 10,
                          }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Rows per page
                          </label>
                        </div>
                        <Col sm="3" style={{ paddingLeft: 0 }}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="Pilih Client"
                            value={options.find(
                              (option) => option.value === totalPerHalaman,
                            )}
                            onChange={handlePageSizeChange}
                            options={options}
                            placeholder="Rows per page"
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col>
                      <ReactPaginate
                        forcePage={page}
                        containerClassName="paginations justify-content-end"
                        previousClassName="pages-items-containers"
                        previousLinkClassName="pages-links-labels"
                        nextClassName="pages-items-containers"
                        nextLinkClassName="pages-links-labels"
                        breakClassName="pages-items-containers"
                        // pageCount={monitoring.rekapLaporan.totalPages}
                        pageCount={totalPage}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        pageLinkClassName="pages-links-labels"
                        pageClassName="pages-items-containers"
                        activeClassName="actives"
                        activeLinkClassName="activess"
                        nextLabel=" > "
                        previousLabel=" < "
                        // initialPage={"page"}
                        disableInitialCallback={true}
                        onPageChange={(val) => {
                          setPage(val.selected);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <h4 className="title">Employees Not Checked In</h4>

            <Card>
              <Card.Body>
                <DataTable
                  columns={colPencairanBelumAbsen}
                  data={paginatedDataBelumAbsen}
                  // {listPencairan.filter(
                  //   (row) =>
                  //     row.id_pinjaman
                  //       .toLowerCase()
                  //       .includes(searchText.toLowerCase()) ||
                  //     row.namaLengkap
                  //       .toLowerCase()
                  //       .includes(searchText.toLowerCase())
                  // )}
                  customStyles={customStyles}
                  paginationPerPage={paginatedDataBelumAbsen}
                  progressPending={loadingBelumAbsen}
                  progressComponent={<TableLoaderBelumAbsen />}
                />

                <div style={{ marginTop: 35 }}>
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Col>
                      <Row style={{ alignItems: "center" }}>
                        <div
                          style={{
                            paddingRight: 0,
                            marginLeft: 20,
                            marginRight: 10,
                          }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Rows per page
                          </label>
                        </div>
                        <Col sm="3" style={{ paddingLeft: 0 }}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="Pilih Client"
                            value={optionsBelumAbsen.find(
                              (optionsBelumAbsen) =>
                                optionsBelumAbsen.value ===
                                totalPerHalamanBelumAbsen,
                            )}
                            onChange={handlePageSizeChangeBelumAbsen}
                            options={optionsBelumAbsen}
                            placeholder="Rows per page"
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col>
                      <ReactPaginate
                        forcePage={pageBelumAbsen}
                        containerClassName="paginations justify-content-end"
                        previousClassName="pages-items-containers"
                        previousLinkClassName="pages-links-labels"
                        nextClassName="pages-items-containers"
                        nextLinkClassName="pages-links-labels"
                        breakClassName="pages-items-containers"
                        // pageCount={monitoring.rekapLaporan.totalPages}
                        pageCount={totalPageBelumAbsen}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        pageLinkClassName="pages-links-labels"
                        pageClassName="pages-items-containers"
                        activeClassName="actives"
                        activeLinkClassName="activess"
                        nextLabel=" > "
                        previousLabel=" < "
                        // initialPage={"page"}
                        disableInitialCallback={true}
                        onPageChange={(val) => {
                          setPageBelumAbsen(val.selected);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <h4 className="title">Manual Attendance</h4>

            <Card>
              <Card.Body>
                <DataTable
                  columns={colPencairanAbsenManual}
                  data={dataAbsenManual}
                  // {listPencairan.filter(
                  //   (row) =>
                  //     row.id_pinjaman
                  //       .toLowerCase()
                  //       .includes(searchText.toLowerCase()) ||
                  //     row.namaLengkap
                  //       .toLowerCase()
                  //       .includes(searchText.toLowerCase())
                  // )}
                  customStyles={customStyles}
                  paginationPerPage={totalPerHalamanAbsenManual}
                  progressPending={loadingAbsenManual}
                  progressComponent={<TableLoaderAbsenManual />}
                />

                <div style={{ marginTop: 35 }}>
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Col>
                      <Row style={{ alignItems: "center" }}>
                        <div
                          style={{
                            paddingRight: 0,
                            marginLeft: 20,
                            marginRight: 10,
                          }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Rows per page
                          </label>
                        </div>
                        <Col sm="3" style={{ paddingLeft: 0 }}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="Pilih Client"
                            value={optionsAbsenManual.find(
                              (optionAbsenManual) =>
                                optionAbsenManual.value ===
                                totalPerHalamanAbsenManual,
                            )}
                            onChange={handlePageSizeChangeAbsenManual}
                            options={optionsAbsenManual}
                            placeholder="Rows per page"
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col>
                      <ReactPaginate
                        forcePage={pageAbsenManual}
                        containerClassName="paginations justify-content-end"
                        previousClassName="pages-items-containers"
                        previousLinkClassName="pages-links-labels"
                        nextClassName="pages-items-containers"
                        nextLinkClassName="pages-links-labels"
                        breakClassName="pages-items-containers"
                        // pageCount={monitoring.rekapLaporan.totalPages}
                        pageCount={totalPageAbsenManual}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        pageLinkClassName="pages-links-labels"
                        pageClassName="pages-items-containers"
                        activeClassName="actives"
                        activeLinkClassName="activess"
                        nextLabel=" > "
                        previousLabel=" < "
                        // initialPage={"page"}
                        disableInitialCallback={true}
                        onPageChange={(val) => {
                          setPageAbsenManual(val.selected);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        size="lg"
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold" }}
          >
            Detail Absensi
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  {/* <Card.Header>
                    <Card.Header>
                      <Card.Title as="h4">Detail Problem</Card.Title>
                    </Card.Header>
                  </Card.Header> */}
                  <Card.Body>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Personnel ID
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">{dataAbsen.nopeg}</Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Name
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">{dataAbsen.nama_karyawan}</Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Position
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">{dataAbsen.jabatan}</Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Shift
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.shift ? dataAbsen.shift : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Check-In Day
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.hari_masuk ? dataAbsen.hari_masuk : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Check-In Date
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.tgl_masuk
                          ? moment(dataAbsen.tgl_masuk).format("DD-MM-YYYY")
                          : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Check-In
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.jam_masuk == null
                          ? "-"
                          : dataAbsen.jam_masuk}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Check-Out Day
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.hari_pulang ? dataAbsen.hari_pulang : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Check-Out Date
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.tgl_pulang
                          ? moment(dataAbsen.tgl_pulang).format("DD-MM-YYYY")
                          : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Check-Out
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.jam_keluar == null
                          ? "-"
                          : dataAbsen.jam_keluar}
                      </Col>
                    </Row>

                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Status
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">{dataAbsen.status}</Col>
                    </Row>
                    <Row>
                      <Col sm="6" style={{ fontWeight: "bold" }}>
                        Description
                      </Col>
                      <Col sm="0.5">:</Col>
                      <Col sm="5">
                        {dataAbsen.keterangan == null
                          ? "-"
                          : dataAbsen.keterangan}
                      </Col>
                    </Row>

                    <Row style={{ marginTop: 30 }}>
                      <Col
                        sm="12"
                        style={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Documentation
                      </Col>
                    </Row>

                    <Row>
                      {!dataAbsen?.dokumen ? (
                        <Col sm="12" style={{ textAlign: "center" }}>
                          Documentation is Not Available
                        </Col>
                      ) : Array.isArray(dataAbsen.dokumen) ? (
                        dataAbsen.dokumen.map((val, index) => (
                          <Col sm="4" key={index}>
                            <Image
                              src={val}
                              style={{
                                width: 200,
                                height: 250,
                                margin: 20,
                                cursor: "pointer",
                              }}
                              thumbnail
                              onClick={() => {
                                setModalPreviewFoto(val);
                              }}
                            />
                          </Col>
                        ))
                      ) : (
                        <Col sm="4">
                          <Image
                            src={`https://backoffice.bapguard.com/Public/izin/${dataAbsen.dokumen}`}
                            style={{
                              width: 200,
                              height: 250,
                              margin: 20,
                              cursor: "pointer",
                            }}
                            thumbnail
                            onClick={() => {
                              setModalPreviewFoto(
                                `https://backoffice.bapguard.com/Public/izin/${dataAbsen.dokumen}`,
                              );
                            }}
                          />
                        </Col>
                      )}
                    </Row>

                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={modalAbsenManual}
        onHide={() => {
          setModalAbsenManual(false);
          setGambar([]);
          setTampilModal("");
          setPilihShift([]);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title id="example-modal-sizes-title-lg">
            Large Modal
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Card className="stacked-form">
                <Card.Header>
                  <Card.Title as="h4">
                    {tampilModal === "add"
                      ? "Create Attendance Manual"
                      : tampilModal === "edit"
                        ? "Edit Attendance Manual"
                        : "Edit Kategori Shift"}
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Form action="#" method="#">
                    <Form.Group>
                      <label>Employee ID</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="text"
                        disabled={true}
                        value={nopeg !== "" ? nopeg : ""}
                        onChange={(e) => {
                          setNopeg(e.target.value);
                        }}
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <label>Name</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="text"
                        disabled={true}
                        value={nama !== "" ? nama : ""}
                        onChange={(e) => {
                          setNama(e.target.value);
                        }}
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <label>Position</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="text"
                        disabled={true}
                        value={jabatan !== "" ? jabatan : ""}
                        onChange={(e) => {
                          setJabatan(e.target.value);
                        }}
                      ></Form.Control>
                    </Form.Group>
                    {/* Edit absen manual dan absen manual */}
                    {(tampilModal === "add" || tampilModal === "edit") && (
                      <>
                        <Form.Group>
                          <label>Shift</label>
                          <Select
                            className="react-select primary pb-2"
                            classNamePrefix="react-select"
                            name="singleSelect"
                            onChange={(value) => {
                              setPilihShift(value);
                            }}
                            options={[
                              {
                                value: "",
                                label: "Pilih Shift",
                                isDisabled: true,
                              },
                              ...listKategoriAbsenBackoffice,
                            ]}
                            value={pilihShift}
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Date Check-in</label>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date Picker Here",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                backgroundColor: "white",
                                color: "black !important",
                              },
                            }}
                            isValidDate={(current) => {
                              const smpDate = moment(smpTgl).startOf("day");
                              return (
                                current.isSameOrAfter(smpDate) &&
                                current.isSameOrBefore(smpDate)
                              );
                            }}
                            onChange={(e) => {
                              set_tgl_absen_masuk(e.toDate().getTime());
                            }}
                            value={moment(tgl_absen_masuk)}
                            timeFormat="HH:mm:ss"
                          ></ReactDatetime>
                        </Form.Group>
                        <Form.Group>
                          <label>Date Check-out</label>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date Picker Here",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                backgroundColor: "white",
                                color: "black !important",
                              },
                            }}
                            isValidDate={(current) => {
                              const smpDate = moment(smpTgl).startOf("day");
                              const nextDate = smpDate.clone().add(1, "day");
                              return (
                                current.isSameOrAfter(smpDate) &&
                                current.isSameOrBefore(nextDate)
                              );
                            }}
                            onChange={(e) => {
                              set_tgl_absen_keluar(e.toDate().getTime());
                            }}
                            value={moment(tgl_absen_keluar)}
                            timeFormat="HH:mm:ss"
                          ></ReactDatetime>
                        </Form.Group>

                        <Form.Group>
                          <label>Status</label>
                          <Select
                            isDisabled={
                              tampilModal === "edit kategori shift"
                                ? true
                                : false
                            }
                            options={statusOption}
                            value={selectedStatusOption}
                            onChange={(selected) => {
                              setStatus(selected.value);
                            }}
                          />
                        </Form.Group>
                      </>
                    )}
                    {/* Edit Kategori Shift */}
                    {tampilModal === "edit kategori shift" && (
                      <Form.Group>
                        <label>Shift</label>
                        <Select
                          className="react-select primary pb-2"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          onChange={(value) => {
                            setPilihShift(value);
                          }}
                          options={[
                            {
                              value: "",
                              label: "Pilih Shift",
                              isDisabled: true,
                            },
                            ...listKategoriAbsenBackoffice,
                          ]}
                          value={pilihShift}
                        />
                      </Form.Group>
                    )}

                    {/* ======================= */}
                    <Form.Group>
                      <label>Note</label>
                      <Form.Control
                        as="textarea"
                        value={keterangan !== "" ? keterangan : ""}
                        onChange={(e) => {
                          setKeterangan(e.target.value);
                        }}
                      ></Form.Control>
                    </Form.Group>

                    {tampilModal === "add" ||
                      (tampilModal === "edit" && (
                        <>
                          <label>Documentation</label>
                          <br />
                          {gambar.length < 3 ? (
                            <>
                              <label
                                className="label-input-file btn btn-danger text-white mb-4"
                                for="import2"
                              >
                                Add Photo
                                <input
                                  type="file"
                                  id="import2"
                                  onClick={(e) => {
                                    e.target.value = "";
                                  }}
                                  onChange={(e) => {
                                    setGambar([
                                      ...gambar,
                                      ...Array.from(e.target.files),
                                    ]);
                                  }}
                                  style={{ display: "none" }}
                                  accept="image/*"
                                  multiple
                                />
                              </label>
                            </>
                          ) : null}

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "15px",
                              marginTop: "15px",
                            }}
                          >
                            {gambar.map((val, index) => {
                              // Handle both File objects dan image URLs
                              const isNewFile = val instanceof File;
                              const imageUrl = isNewFile
                                ? URL.createObjectURL(val)
                                : val.url || val;
                              const imageName =
                                val.name ||
                                (isNewFile ? val.name : `Image ${index + 1}`);

                              return (
                                <div
                                  key={index}
                                  style={{
                                    position: "relative",
                                    display: "inline-block",
                                    border: isNewFile
                                      ? "3px solid #4CAF50"
                                      : "2px solid #e0e0e0",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  <img
                                    src={imageUrl}
                                    alt={`preview-${index}`}
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      objectFit: "cover",
                                      display: "block",
                                    }}
                                    onError={(e) => {
                                      e.target.src =
                                        "https://via.placeholder.com/150?text=Invalid+Image";
                                    }}
                                  />
                                  {isNewFile && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "5px",
                                        left: "5px",
                                        backgroundColor: "#4CAF50",
                                        color: "white",
                                        fontSize: "10px",
                                        padding: "4px 8px",
                                        borderRadius: "4px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      NEW
                                    </div>
                                  )}
                                  <Button
                                    onClick={() => {
                                      setGambar([
                                        ...gambar.slice(0, index),
                                        ...gambar.slice(
                                          index + 1,
                                          gambar.length,
                                        ),
                                      ]);
                                    }}
                                    variant="danger"
                                    size="sm"
                                    style={{
                                      position: "absolute",
                                      top: "5px",
                                      right: "5px",
                                      borderRadius: "50%",
                                      width: "32px",
                                      height: "32px",
                                      padding: "0",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      backgroundColor: "rgba(255, 0, 0, 0.8)",
                                      border: "none",
                                      cursor: "pointer",
                                      transition: "all 0.3s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor =
                                        "rgba(255, 0, 0, 1)";
                                      e.target.style.transform = "scale(1.1)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor =
                                        "rgba(255, 0, 0, 0.8)";
                                      e.target.style.transform = "scale(1)";
                                    }}
                                  >
                                    <i
                                      className="fa fa-times"
                                      style={{
                                        color: "white",
                                        fontSize: "16px",
                                      }}
                                    />
                                  </Button>
                                  <div
                                    style={{
                                      padding: "8px",
                                      fontSize: "12px",
                                      color: "#666",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      backgroundColor: "#fafafa",
                                      borderTop: "1px solid #e0e0e0",
                                    }}
                                  >
                                    {imageName}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      ))}
                  </Form>
                </Card.Body>
                <Card.Footer>
                  <Button
                    onClick={() => {
                      tampilModal === "add"
                        ? absenManual()
                        : tampilModal === "edit"
                          ? editManual()
                          : editKategori();
                    }}
                    className="btn-fill"
                    type="submit"
                    variant="info"
                  >
                    Submit
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={modalExport}
        onHide={() => {
          setModalExport(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card style={{ border: 0 }}>
                  <Card.Header>
                    <Card.Header>
                      <Card.Title
                        as="h4"
                        style={{
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textAlign: "center",
                        }}
                      >
                        Export Data Attendance Excel
                        <hr></hr>
                      </Card.Title>
                    </Card.Header>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Start Date
                          </label>
                          <Form.Control
                            onChange={(e) => {
                              setTglAwalExport(e.target.value);
                            }}
                            type="date"
                            value={tglAwlExport}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => e.target.showPicker()}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            End Date
                          </label>
                          <Form.Control
                            onChange={(e) => {
                              setTglAkhirExport(e.target.value);
                            }}
                            type="date"
                            value={tglAkhirExport}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => e.target.showPicker()}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Button
                      // className="btn-fill pull-right"
                      // type="submit"
                      // variant="info"
                      style={{
                        marginTop: 5,
                        backgroundColor: "#417DA0",
                        border: 0,
                        fontWeight: "bold",
                      }}
                      onClick={exportAbsen}
                    >
                      Submit
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={modalExportPdf}
        onHide={() => {
          setModalExportPdf(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card style={{ border: 0 }}>
                  <Card.Header>
                    <Card.Header>
                      <Card.Title
                        as="h4"
                        style={{
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textAlign: "center",
                        }}
                      >
                        Export Data Attendance PDF
                        <hr></hr>
                      </Card.Title>
                    </Card.Header>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Select Month
                          </label>

                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Select Month",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                backgroundColor: "#f8f9fa",
                                borderRadius: 8,
                                border: "1px solid #ced4da",
                                height: 42,
                                paddingLeft: 12,
                              },
                            }}
                            onChange={(e) => {
                              setExportPdf(e.clone().startOf("month"));
                            }}
                            value={exportPdf}
                            initialValue={exportPdf}
                            timeFormat={false}
                            dateFormat="MMMM YYYY"
                          ></ReactDatetime>
                        </Form.Group>
                      </Col>
                      {/* <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            End Date
                          </label>
                          <Form.Control
                            onChange={(e) => {
                              setTglAkhirExport(e.target.value);
                            }}
                            type="date"
                            value={tglAkhirExport}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => e.target.showPicker()}
                          />
                        </Form.Group>
                      </Col> */}
                    </Row>

                    <Button
                      // className="btn-fill pull-right"
                      // type="submit"
                      // variant="info"
                      style={{
                        marginTop: 5,
                        backgroundColor: "#417DA0",
                        border: 0,
                        fontWeight: "bold",
                      }}
                      onClick={exportAbsenPdf}
                    >
                      Submit
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ReactTables;
